import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { type TickStatus } from '../../../../types';
import { pocketWithinRange } from '../../../../utilities';
import { StatusGradient } from '../../../StatusGradient';

import { Background, Content, Count, StyledPocket } from './styles';

export interface PocketProps {
    status?: TickStatus;
    count?: number;
    active?: boolean;
}

export function Pocket({ status, count = 1, active = false }: PocketProps) {
    const statusGradientMarkup = active ? <StatusGradient status={status} /> : null;
    const formattedCount = pocketWithinRange(count);

    return (
        <StyledPocket $active={active}>
            <Background>
                <AnimatePresence initial={false}>{statusGradientMarkup}</AnimatePresence>
            </Background>

            <Content>
                <Count key={`TicksMeter-Pocket-Count-${count}`}>+{formattedCount}</Count>
            </Content>
        </StyledPocket>
    );
}
